<template>
  <ul class="copy-list">
    <copy-list-item
      number="01"
      title="concept<br>big idea"
      :texts="[
        'Myślimy turbo kreatywnie,<br>działamy szeroko, wyprzedzamy<br>trendy i&nbsp;wiemy, na&nbsp;czym polega<br>przygotowanie przemyślanej<br>BIG&nbsp;IDEA.',
        'Forma prezentacji ma dla nas<br>znaczenie.'
      ]"
    />
    <copy-list-item
      number="02"
      title="digitally<br>driven"
      :texts="[
        'Jesteśmy świadomi<br>DIGITAL POWER i&nbsp;mamy wiedzę<br>analityczną, którą czerpiemy<br>od mocnego partnera strategicznego.',
        'Nasz hype to przemyślana<br>kreacja x&nbsp;liczby.'
      ]"
    />
    <copy-list-item
      number="03"
      title="execution"
      :texts="[
        'Za każdym razem dobieramy<br>odpowiedni zespół ludzi<br>- zarówno ten kreatywny jak<br>i&nbsp;produkcyjny. Polegamy<br>na&nbsp;silnym zespole wewnątrz organizacji oraz współpracujemy<br>z&nbsp;doświadczonymi<br>podwykonawcami.'
      ]"
    />
  </ul>
</template>
<script>
import TextHighlight from '@/components/TextHighlightAnimation/TextHighlight'
import TextWithLineHighlight from '@/components/TextHighlightAnimation/TextWithLineHighlight'
import NumberHighlight from '@/components/TextHighlightAnimation/NumberHighlight'
import CopyListItem from '@/components/CopyListItem'
export default {
  components: {
    TextHighlight,
    TextWithLineHighlight,
    NumberHighlight,
    CopyListItem
  }
}
</script>
<style lang="scss" scoped>
  .copy-list {
    @include reset-list;
  }
</style>



// WEBPACK FOOTER //
// src/components/CopyList.vue